import { Layers } from 'lucide-react';
import { DesignsList } from '@/features/designs/DesignsList';

export function SlabsAnalysisIndexPage() {
  return (
    <DesignsList
      module="analysis_losas"
      description="Análisis estructural de losas — abre uno guardado o crea uno nuevo."
      icon={<Layers size={24} strokeWidth={1.5} />}
    />
  );
}
